import { render, staticRenderFns } from "./StepNavigationTitle.vue?vue&type=template&id=5961b5f4&scoped=true&"
import script from "./StepNavigationTitle.vue?vue&type=script&lang=js&"
export * from "./StepNavigationTitle.vue?vue&type=script&lang=js&"
import style0 from "./StepNavigationTitle.vue?vue&type=style&index=0&id=5961b5f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961b5f4",
  null
  
)

export default component.exports